import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IntermediariosService } from "./intermediarios.service";
import { Intermediario } from "../../Modelos/Intermediario";
import { isArray } from "util";

declare let mostrarToast: Function;
declare let actualizarCampos: Function;

@Component({
    selector: 'intermediarios',
    templateUrl: 'intermediarios.component.html'
})
export class IntermediariosComponent implements OnInit, OnChanges{

    @Input() codigoRamo;
    @Input() codigoAgencia;
    @Input() codigoPuntoVenta;

    @Output() alternarLoader=new EventEmitter();

    @Input() claveIntermediario: string;
    @Input() usuarioIntermediario: boolean;
    @Input() intermediarios: Intermediario[];
    
    constructor(private intermediariosService: IntermediariosService){}

    async ngOnInit() {
        this.claveIntermediario="";
    }

    async ngOnChanges(changes: SimpleChanges){
        if(changes.hasOwnProperty("puntoVenta") || changes.hasOwnProperty("codigoRamo")){
            if(this.codigoPuntoVenta && this.codigoRamo && this.claveIntermediario)
                this.consultarIntermediario();
            else
                this.intermediarios=[];
        }
    }

    async consultarIntermediario(){
        this.alternarLoader.emit();
        if(!this.validarEntradaIntermediario())
            return;

        let resultadoIntermediario=await this.intermediariosService.consultarIntermediario(
            "I",
            parseInt(this.claveIntermediario),
            this.codigoRamo,
            this.codigoAgencia,
            this.codigoPuntoVenta
        );

        if(!resultadoIntermediario){
            this.alternarLoader.emit();
            mostrarToast("El intermediario no corresponde con la sucursal y/o punto de venta seleccionados.");
            return;
        }
        if(resultadoIntermediario.error)
            if(resultadoIntermediario.error.toLowerCase()!= 'ok'){
                this.alternarLoader.emit();
                mostrarToast(resultadoIntermediario.error)
                return;
            }
        resultadoIntermediario.intermediario_id=Math.floor((Math.random() * 100) + 1);
        resultadoIntermediario.clave=this.claveIntermediario;
        this.intermediarios.push(resultadoIntermediario);
        actualizarCampos();
        this.alternarLoader.emit();
    }

    validarEntradaIntermediario(): boolean{
        let mensaje="";
        if(this.claveIntermediario=="")
            mensaje+="<li>Clave Intermediario</li>";
        if(!this.codigoAgencia)
            mensaje+="<li>Agencia</li>";
        if(!this.codigoRamo)
            mensaje+="<li>Ramo</li>";
        if(!this.codigoPuntoVenta)
            mensaje+="<li>Punto Venta</li>";

        if(mensaje!=""){
            this.alternarLoader.emit();
            mostrarToast(`<ul><li>Campos requeridos:</li>${mensaje}</ul>`);
            return false;
        }
        return true;
    }

    borrarIntermediario(id: number){
        this.intermediarios.splice(this.intermediarios.findIndex(x=>x.intermediario_id==id), 1);
        actualizarCampos();
    }
}